import { defineElement, html, TemplateElement, unsafeHTML } from '@webtides/element-js';
import { decodeIfEscaped, getImageAttributes } from '@/services/content-service.js';
import '../../../../src/components/@e-banking/components/e-banking-notification/e-banking-notification.js';

class EditableNotification extends TemplateElement {
    properties() {
        return {
            content: {},
        };
    }
    injectProperties() {
        return { environment: null };
    }

    get iconData() {
        return getImageAttributes(this.environment, this.content?.icon, 150);
    }

    template() {
        return html`
            <mb-e-banking-notification
                .title="${this.content.title}"
                .text="${this.content.text}"
                .icon="${this.iconData}"
                .variant="${this.content.variant}"
                .iconPosition="${this.content.iconPosition}"
            ></mb-e-banking-notification>
        `;
    }
}

defineElement('editable-notification', EditableNotification);
